import React from 'react';

export default class NrgSchema extends React.Component {

  render() {
    return(
      <script type="application/ld+json" dangerouslySetInnerHTML={ { __html: this.getSnippet() } }></script>
    );
  }

  getSnippet() {
    return (
      `{ "@context": "http://schema.org",
 "@type": "Organization",
 "name": "National Research Group",
 "alternateName": "NRG",
 "url": "http://forms.nrgmr.com",
 "logo": "http://forms.nrgmr.com/assets/img/nrglogo.png",
 "address":
    [
        {
            "@type": "PostalAddress",
		"streetAddress": "12101 W. Bluff Creek Drive",
 		"addressLocality": "Los Angeles",
 		"addressRegion": "CA",
 		"postalCode": "90094",
		"addressCountry": "USA"
        },
        {
            "@type": "PostalAddress",
		"streetAddress": "5th Floor � Endeavour House, 189 Shaftesbury Avenue",
 		"addressLocality": "London, England",
 		"postalCode": "WC2H 8JR"
        }
    ],
 "contactPoint": {
 "@type": "ContactPoint",
 "contactType": "customer support",
 "telephone": "+1-323-406-6200",
 "email": "inquiry@nrgmr.com" 
 },
 "sameAs": [ 
 "https://www.facebook.com/nationalresearchgroup/", 
 "https://www.linkedin.com/company/national-research-group-a-stagwell-company"
 ]}`
    );
  }

}
